<template>
  <div class="wrapper">
    <div class="container">
      <van-popup v-model="areaShow" :lock-scroll="true">
        <div class="areaPopup">
          <div class="areaTitle">可用{{areaTitle}}</div>
          <span class="areaText">{{areaText}}</span>
        </div>
      </van-popup>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div v-if="menu[0].list.length>0" class="titleText">可使用{{type==1?'优惠券':'折扣券'}}({{menu[0].totalRows}})</div>
        <van-list
          id="scroll"
          :immediate-check="false"
          v-model="menu[0].loading"
          :finished="menu[0].finished"
          :offset="20"
          @load="getCanUseCoupon"
        >
          <div
            class="couponbox"
            v-for="(item,index) in menu[0].list"
            :key="index"
            @click="select(index)"
          >
            <!-- 分割线 -->
            <div class="line">
              <div class="circle c_t"></div>
              <div class="circle c_b"></div>
            </div>
            <div class="leftCircle">
              <div class="circle1"></div>
              <div class="circle1"></div>
              <div class="circle1"></div>
              <div class="circle1"></div>
              <div class="circle1"></div>
              <div class="circle1"></div>
            </div>
            <div class="rightCircle">
              <div class="circle1"></div>
              <div class="circle1"></div>
              <div class="circle1"></div>
              <div class="circle1"></div>
              <div class="circle1"></div>
              <div class="circle1"></div>
            </div>
            <!-- 左侧满减券 -->
            <div class="left" v-if="item.limit_condition !=0">
              <!-- 减得金额 -->
              <div class="top">
                <span class="icon red">￥</span>
                <span class="money">{{parseFloat(parseFloat(item.limit_amount).toFixed(2))}}</span>
              </div>
              <div class="bot">满{{parseFloat(parseFloat(item.limit_condition).toFixed(2))}}元使用</div>
            </div>
            <!-- 左侧无门槛券 -->
            <div class="left" v-if="item.limit_condition==0">
              <!-- 减得金额 -->
              <div class="top">
                <span class="icon red">￥</span>
                <span class="money">{{parseFloat(parseFloat(item.limit_amount).toFixed(2))}}</span>
              </div>
              <div class="bot">无门槛券</div>
            </div>
            <div class="mid">
              <span class="top">{{type==1?item.name:item.discount_name}}</span>
              <span class="bot">{{type==1?item.end_time+'到期':item.area_name}}</span>
              <span @click.stop="showArea(item)" class="area" v-if="item.area_name&&type==1">
                限定专场可用
                <img src="./../../assets/images/myCoupon/fill2.png" alt />
              </span>
              <span @click.stop="showArea(item)" class="area" v-if="item.commodity_name&&type==1">
                限定商品可用
                <img src="./../../assets/images/myCoupon/fill2.png" alt />
              </span>
            </div>
            <div class="right">
              <span class="notice due" v-if="item.is_end==1">即将到期</span>
              <span class="notice due2" v-if="item.is_start==1">新增券</span>
              <span class="selectBtn" @click="use" v-if="type==1">
                <img
                  v-if="coupon.received_nbr==item.received_nbr"
                  src="./../../assets/images/icon_xuanzhong.png"
                  alt
                />
                <img v-else src="./../../assets/images/icon_weixuan.svg" alt />
              </span>
              <span class="selectBtn" v-if="type==2">
                <img
                  v-if="areaCoupon.discount_nbr==item.discount_nbr"
                  src="./../../assets/images/icon_xuanzhong.png"
                  alt
                />
                <img v-else src="./../../assets/images/icon_weixuan.svg" alt />
              </span>
            </div>
          </div>
          <div v-if="menu[0].list.length>0" style="height:.24rem"></div>
        </van-list>
        <div
          v-if="menu[1].list.length>0"
          class="titleText"
          :style="menu[0].list.length>0?{'margin-top':0}:{}"
        >不可使用优惠券({{menu[1].totalRows}})</div>
        <van-list
          id="scroll"
          :immediate-check="false"
          v-model="menu[1].loading"
          :finished="menu[1].finished"
          :offset="20"
          @load="getUnUseCoupon"
        >
          <div
            class="no"
            v-if="menu[0].list.length == 0&&menu[1].list.length == 0&&!menu[1].loading&&!menu[0].loading"
          >
            <img src="./../../assets/images/myCoupon/Bitmap.png" alt />
            <div>您当前无可使用优惠券哦~</div>
          </div>
          <div v-for="(item,index) in menu[1].list" :key="index">
            <div class="couponbox grey">
              <div class="line">
                <div class="circle c_t"></div>
                <div class="circle c_b"></div>
              </div>
              <div class="leftCircle">
                <div class="circle1"></div>
                <div class="circle1"></div>
                <div class="circle1"></div>
                <div class="circle1"></div>
                <div class="circle1"></div>
                <div class="circle1"></div>
              </div>
              <div class="rightCircle">
                <div class="circle1"></div>
                <div class="circle1"></div>
                <div class="circle1"></div>
                <div class="circle1"></div>
                <div class="circle1"></div>
                <div class="circle1"></div>
              </div>
              <div class="left" v-if="item.limit_condition !=0">
                <div class="top">
                  <span class="icon red">￥</span>
                  <span class="money">{{parseFloat(parseFloat(item.limit_amount).toFixed(2))}}</span>
                </div>
                <div class="bot">满{{parseFloat(parseFloat(item.limit_condition).toFixed(2))}}元使用</div>
              </div>
              <div class="left" v-if="item.limit_condition==0">
                <div class="top">
                  <span class="icon red">￥</span>
                  <span class="money">{{parseFloat(parseFloat(item.limit_amount).toFixed(2))}}</span>
                </div>
                <div class="bot">无门槛券</div>
              </div>
              <div class="mid">
                <span class="top">{{item.name}}</span>
                <div style="display:flex;flexDirection:column;">
                  <span v-if="item.start_time_result==1" class="bot">{{item.start_time}}</span>
                  <span class="bot">
                    <i v-if="item.start_time_result==1">-</i>
                    {{item.end_time}}
                    <i v-if="item.start_time_result!=1">到期</i>
                  </span>
                  <span @click="showArea(item)" class="area" v-if="item.area_name&&type==1">
                    限定专场可用
                    <img src="./../../assets/images/myCoupon/fill1.png" alt />
                  </span>
                  <span @click.stop="showArea(item)" class="area" v-if="item.commodity_name&&type==1">
                    限定商品可用
                    <img src="./../../assets/images/myCoupon/fill2.png" alt />
                  </span>
                </div>
              </div>
              <div class="right">
                <span class="notice due" v-if="item.is_end==1">即将到期</span>
                <span class="notice due2" v-if="item.is_start==1">新增券</span>
                <span class="selectBtn">
                  <img
                    v-if="coupon.coupon_nbr==item.received_nbr"
                    src="./../../assets/images/icon_xuanzhong.png"
                    alt
                  />
                  <img v-else src="./../../assets/images/icon_weixuan.svg" alt />
                </span>
              </div>
            </div>
            <div class="reason">
              <span style="color: #E52B25 !important;">本单不可用原因：</span>
              <div class="value">
                <span v-if="item.limit_amount_result==1">消费金额不足</span>
                <span v-if="item.limit_condition_result==1">满减额度不够</span>
                <span v-if="item.start_time_result==1">开始时间未到</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      totalprice: "",
      isLoading: false,
      myCouponsList: [],
      numPerPage: 10,
      areaShow: false,
      areaText: "",
      areaTitle:'',
      type:'1',
      menu: [
        {
          list: [],
          pageIndex: 0,
          totalRows: 0,
          loading: true, //上拉加载
          finished: false //加载完成
        },
        {
          list: [],
          pageIndex: 0,
          totalRows: 0,
          loading: false, //上拉加载
          finished: true //加载完成
        }
      ]
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["userInfo", "coupon","areaCoupon"])
  },
  methods: {
    onRefresh() {
      this.menu[0].list = [];
      this.menu[0].pageIndex = 0;
      this.menu[0].loading = true;
      this.menu[0].finished = false;
      this.menu[1].list = [];
      this.menu[1].pageIndex = 0;
      this.getCanUseCoupon();
    },
    showArea(item) {
      if(item.commodity_name){
        this.areaShow = true;
        this.areaTitle = '商品'
        this.areaText = item.commodity_name;
      }
      if(item.area_name){
        this.areaShow = true;
        this.areaTitle = '专场'
        this.areaText = item.area_name;
      }
    },
    /**
     * 选择优惠券
     */
    select(index) {
      if (!this.totalprice) {
        return;
      }
      // if(this.active==1){
      //   return this.$toast({
      //     message: '该优惠券已使用',
      //     duration: 2000
      //   });
      // }
      // else if(this.active==2){
      //   return this.$toast({
      //     message: '该优惠券已过期',
      //     duration: 2000
      //   });
      // }
      let nbr = this.type==1 ?this.coupon.nbr:this.areaCoupon.discount_nbr
      let couponNbr = this.type==1 ? this.menu[0].list[index].nbr: this.menu[0].list[index].discount_nbr
      if ( nbr == couponNbr) {
        this.type==1?this.$store.commit("SENDcoupon", ""):this.$store.commit("SENDAreaCoupon", "");
      } else {
        this.menu[0].list[index].totalprice = this.totalprice
        this.type==1?this.$store.commit("SENDcoupon", this.menu[0].list[index]):this.$store.commit("SENDAreaCoupon", this.menu[0].list[index]);
      }
      this.$router.go(-1);
    },
    /**
     * 去使用优惠券
     * @param
     */
    use() {
      if (this.totalprice) {
        return;
      }
      this.$router.push({
        path: "/index",
        query: { supNbr: this.userInfo.nbr }
      });
    },
    getCanUseCoupon() {
      this.menu[0].loading = true; //手动控制上啦正在加载，防止多次请求
      let obj = {
        jydm: this.type==1?'flow_70132':'flow_70194'
      }
      obj[`${this.type==1?'flow_70132':'flow_70194'}`] = {
        user_nbr: this.userInfo.nbr,
        price: this.totalprice,
        commodity: {
          nbr: JSON.parse(this.$route.query.arr)
        },
        page_index: this.menu[0].pageIndex * this.numPerPage,
        num_per_page: this.numPerPage
      }
      this.$commonPost(obj)
        .then(response => {
          let arr = [];
          if (response.coupon) {
            if (response.coupon.length > 0) {
              arr = response.coupon;
            } else {
              arr.push(response.coupon);
            }
          }
          if (response.discount) {
            if (response.discount.length > 0) {
              arr = response.discount;
            } else {
              arr.push(response.discount);
            }
          }
          this.menu[0].list = this.menu[0].list.concat(arr);
          this.isLoading = false;
          this.menu[0].loading = false;
          this.menu[0].totalRows = response.total_rows;
          if (response.total_rows <= this.menu[0].list.length) {
            this.menu[0].finished = true;
            this.menu[1].finished = true;
            this.type==1?this.getUnUseCoupon():'';
          } else {
            this.menu[0].pageIndex += 1;
            this.menu[0].finished = false;
          }
        })
        .catch(err => {
          this.isLoading = false;
          this.menu[0].loading = false;
          this.menu[0].finished = true;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getUnUseCoupon() {
      return  this.menu[1].finished = true
      this.menu[1].loading = true; //手动控制上啦正在加载，防止多次请求
      this.$commonPost({
        jydm: "flow_70133",
        flow_70133: {
          user_nbr: this.userInfo.nbr,
          price: this.totalprice,
          commodity: {
            nbr: JSON.parse(this.$route.query.arr)
          },
          page_index: this.menu[1].pageIndex * this.numPerPage,
          num_per_page: this.numPerPage
        }
      })
        .then(response => {
          let arr = [];
          if (response.coupon) {
            if (response.coupon.length > 0) {
              arr = response.coupon;
            } else {
              arr.push(response.coupon);
            }
          }
          this.menu[1].list = this.menu[1].list.concat(arr);
          if (response.total_rows <= this.menu[1].list.length) {
            this.menu[1].finished = true;
          } else {
            this.menu[1].pageIndex += 1;
            this.menu[1].finished = false;
          }
          this.isLoading = false;
          this.menu[1].loading = false;
          this.menu[1].totalRows = response.total_rows;
        })
        .catch(err => {
          this.isLoading = false;
          this.menu[1].loading = false;
          this.menu[1].finished = true;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    initPage() {
      if (this.$route.query.price) {
        this.totalprice = this.$route.query.price;
      }
      if (this.$route.query.type) {
        this.type = this.$route.query.type||1;
      }
      document.title = this.type==1?"优惠券":"满减折扣";
      let option = {
        title: "有米@" + this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
      this.getCanUseCoupon();
    }
  },
  created() {
    this.initPage();
  },
  mounted() {}
};
</script>
<style scoped lang='stylus'>
.container >>> .van-tab {
  font-size: 0.28rem;
  color: #333;
}

.container >>> .van-tab--active {
  font-weight: normal !important;
  color: #E52B25;
}

.wrapper >>> .van-pull-refresh__track {
  min-height: calc(100vh - 1.36rem);
}

.wrapper >>> .no {
  margin: 0 auto 0;
  padding-top: 1.86rem;
  text-align: center;
}

.wrapper >>> .no img {
  width: 2.94rem;
  height: 1.78rem;
}

.wrapper >>> .no div {
  font-size: 0.28rem;
  color: #999;
  margin-top: 0.3rem;
  line-height: 0.4rem;
}

.wrapper >>> .no span {
  margin-top: 0.6rem;
  width: 5.92rem;
  height: 1.4rem;
  border: 2px solid #E52B25;
  border-radius: 0.8rem;
  display: inline-block;
  color: #E52B25;
  line-height: 1.4rem;
  text-align: center;
  font-size: 0.6rem;
  transform: scale(0.5);
  transform-origin: top;
}

.wrapper >>> .van-popup {
  border-radius: 0.2rem;
}
</style>
<style scoped lang='less'>
.wrapper {
  width: 100%;
}
.areaPopup {
  width: 5.92rem;
  height: 3.34rem;
  background: #fff;
  .areaTitle {
    text-align: center;
    line-height: 0.5rem;
    margin-top: 0.4rem;
    margin-bottom: 0.54rem;
    font-size: 0.36rem;
    font-weight: bold;
  }
  .areaText {
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    font-size: 0.28rem;
    line-height: 0.4rem;
  }
}
.area {
  font-size: 0.2rem;
  color: #333;
  line-height: 0.3rem;
  margin-top: 0.1rem;
  display: flex;
  align-items: center;
  padding: 0;
  img {
    width: 0.24rem;
    height: 0.24rem;
    margin-left: 0.06rem;
  }
}
.container {
  min-height: 100vh;
  background: #f5f5f5;
  box-sizing: border-box;
}

.container {
  min-height: 100vh;
  background: #f5f5f5;
  box-sizing: border-box;
}
.titleText {
  margin-top: 0.24rem;
  margin-bottom: 0.3rem;
  font-size: 0.28rem;
  color: #000;
  font-weight: bold;
  display: inline-block;
  padding-left: 0.3rem;
}
.couponbox {
  width: 6.9rem;
  height: 1.88rem;
  background: #fff;
  display: flex;
  position: relative;
  margin-bottom: 0.11rem;
  box-sizing: border-box;
  // border-radius: 0.2rem;
  &:last-child {
    margin-bottom: 0;
  }
}
.reason {
  display: flex;
  width: 6.7rem;
  flex-wrap: nowrap;
  margin-left: 0.2rem;
  margin-bottom: 0.3rem;
  span {
    font-size: 0.24rem;
    font-weight: 400;
    line-height: 0.34rem;
  }
  .value {
    flex: 1;
    span {
      color: #999 !important;
      margin-right: 0.2rem;
      white-space: nowrap;
    }
  }
}
#scroll {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

/* left */
.couponbox .left {
  width: 2.16rem;
  display: flex;
  height: 100%;
  height: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background-image: linear-gradient(-135deg, #fa5b4d 0%, #ff0e45 100%);
}

.couponbox .left .top {
  display: flex;
  justify-content: center;
  align-items: baseline;
  font-family: 700;
  font-size: 0.6rem;
  margin-bottom: 0.16rem;
  color: #fff;
}

.couponbox .left .top .icon {
  font-size: 0.3rem;
  font-family: 700;
}

.couponbox .left .top .icon.red {
  font-weight: bold;
}

.couponbox .left .bot {
  font-size: 0.22rem;
  color: #fff;
}

/* 线 */
.line {
  width: 0.02rem;
  position: absolute;
  left: 2.1rem;
  z-index: 4;
  height: 100%;
}
.leftCircle {
  width: 0.02rem;
  position: absolute;
  left: -0.09rem;
  z-index: 4;
  height: 100%;
}
.rightCircle {
  width: 0.02rem;
  position: absolute;
  right: 0.09rem;
  z-index: 4;
  height: 100%;
}

.circle {
  width: 0.2rem;
  height: 0.2rem;
  border-radius: 50%;
  background: #f5f5f5;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.circle1 {
  width: 0.18rem;
  height: 0.18rem;
  border-radius: 50%;
  background: #f5f5f5;
  margin-top: 0.12rem;
}

.line .c_t {
  top: -0.1rem;
}

.line .c_b {
  bottom: -0.1rem;
}

/* mid */
.couponbox .mid {
  display: flex;
  flex: 1;
  justify-content: center;
  flex-direction: column;
  padding-left: 0.28rem;
}

.mid .top {
  font-size: 0.28rem;
  color: #333333;
  font-weight: bold;
  margin-bottom: 0.14rem;
  line-height: 0.4rem;
  width: 3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.mid .bot {
  font-size: 0.22rem;
  color: #999999;
  line-height: 0.3rem;
}

/* right */
.couponbox.grey {
  * {
    color: #ccc !important;
  }
  .left .icon,
  .left .money,
  .left .bot {
    color: #fff !important;
  }
  .left {
    background: #ddd !important;
  }
}
.couponbox .right {
  width: 1.56rem;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: relative;
  img {
    width: 1rem;
    height: 1rem;
  }
}
.notice {
  width: 1.92rem;
  height: 0.56rem;
  position: absolute;
  font-size: 0.4rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.08rem;
  top: 0.1rem;
  transform: scale(0.5);
  transform-origin: top;
}
.due {
  background: #e52b25;
}
.due2 {
  background: #5c71fd;
}
.selectBtn {
  width: 100%;
  box-sizing: border-box;
  padding-right: 0.29rem;
  display: flex;
  justify-content: flex-end;
  img {
    width: 0.4rem !important;
    height: 0.4rem !important;
  }
}
.usebtn {
  background-image: linear-gradient(-139deg, #fdb16f 0%, #ff610b 100%);
  border-radius: 0.48rem;
  display: flex;
  height: 0.8rem;
  width: 2.08rem;
  font-size: 0.56rem;
  color: #ffffff;
  justify-content: center;
  align-items: center;
  transform: scale(0.5);
  line-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/information/couponCommodity.vue